import { Select } from "antd";

const AllDropDowns = ({
  value,
  setValue,
  title,
  dropDownMenu,
  selectedwidth,
  defaultValue,
  placeholder,
  selectedClassName,
  fontSize,
}) => {
  return (
    <div className="d-flex flex-column align-items-start my-2">
      <label style={{ fontSize: fontSize }} className="fw-bold">
        {title}{" "}
      </label>
      <Select
        defaultValue={defaultValue}
        className={selectedClassName}
        style={{
          width: selectedwidth,
          fontSize: "16px",
          fontWeight: "500",
          lineHeight: "24px",
        }}
        value={value}
        onChange={(e) => setValue(e)}
        placeholder={placeholder}
        placement={"bottomRight"}
        optionFilterProp="children"
        filterOption={(input, option) => (option?.label ?? "").includes(input)}
        // filterSort={(optionA, optionB) =>
        //     (optionA?.label ?? "")
        //         .toLowerCase()
        //         .localeCompare((optionB?.label ?? "").toLowerCase())
        // }
        options={dropDownMenu}
      />
    </div>
  );
};
export default AllDropDowns;
